import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectUrlPath } from '../selectors';

export default function ScrollToTop() {
  const urlPath = useSelector(selectUrlPath);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [urlPath]);

  return null as any;
}
